import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


const adminRouters = [
  {
    path: '/admin',
    name: 'login',
    meta: ['登录'],
    component: () => import('@/views/admin/Login.vue')
  },
  {
    path: '/admin/home',
    name: 'home',
    component: () => import('@/views/admin/Home.vue'),
    children: [
      { path: '', redirect: 'index' },
      {
        path: 'index',
        component: () => import('@/views/admin/Index.vue'),
      },
      {
        path: 'userinfo/person',
        meta: ['个人中心', '个人资料'],
        component: () => import('@/views/admin/Userinfo.vue'),
      },
      {
        path: 'userinfo/updatepwd',
        meta: ['个人中心', '修改密码'],
        component: () => import('@/views/admin/Updatepwd.vue'),
      },
      {
        path: 'system/user',
        meta: ['系统管理', '用户管理'],
        component: () => import('@/views/admin/User.vue'),
      },
      {
        path: 'system/role',
        meta: ['系统管理', '角色管理'],
        component: () => import('@/views/admin/Role.vue'),
      },
      {
        path: 'system/menu',
        meta: ['系统管理', '菜单管理'],
        component: () => import('@/views/admin/Menu.vue'),
      },
      {
        path: 'system/permission',
        meta: ['系统管理', '权限管理'],
        component: () => import('@/views/admin/Permission.vue'),
      },
      {
        path: 'system/carousel',
        meta: ['系统管理', '轮播图管理'],
        component: () => import('@/views/admin/Carousel.vue'),
      },
      {
        path: 'game/category',
        meta: ['游戏', '类别管理'],
        component: () => import('@/views/admin/GameCategory.vue'),
      },
      {
        path: 'game/tag',
        meta: ['游戏', '标签管理'],
        component: () => import('@/views/admin/GameTag.vue'),
      },
      {
        path: 'game/game',
        meta: ['游戏', '游戏管理'],
        component: () => import('@/views/admin/Game.vue'),
      },
      {
        path: 'game/account',
        meta: ['游戏', '账号管理'],
        component: () => import('@/views/admin/Account.vue'),
      },
      {
        path: 'order/orderAccount',
        meta: ['订单', '订单管理'],
        component: () => import('@/views/admin/OrderAccount.vue'),
      },
      {
        path: 'order/evaluation',
        meta: ['订单', '订单评价'],
        component: () => import('@/views/admin/Evaluation.vue'),
      },
      {
        path: 'blog/notice',
        meta: ['公告', '帖子管理'],
        component: () => import('@/views/admin/Notice.vue'),
      },
      {
        path: 'blog/review',
        meta: ['公告', '留言管理'],
        component: () => import('@/views/admin/Review.vue'),
      },
      {
        path: 'chat/userChat',
        meta: ['聊天', '聊天记录'],
        component: () => import('@/views/admin/Message.vue'),
      },
      {
        path: 'collect/collection',
        meta: ['收藏夹', '收藏管理'],
        component: () => import('@/views/admin/CollectionRecord.vue'),
      },
    ]
  }
]


const frontRouters = [
  {
    path: '/',
    name: 'login',
    meta: '登录',
    component: () => import('@/views/front/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/front/Register.vue')
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: () => import('@/views/front/PrivacyPolicy.vue')
  },
  {
    path: '/home',
    name: 'home',
    meta: '主页',
    component: () => import('@/views/front/Home.vue'),
    children: [
      { path: '', redirect: 'index' },
      {
        path: 'index',
        component: () => import('@/views/front/Index.vue'),
      },
      {
        path: 'userCenter',
        name: 'userCenter',
        component: () => import('@/views/front/UserCenter/UserCenter.vue')
      },
      {
        path: 'updatePwd',
        name: 'updatePwd',
        component: () => import('@/views/front/UpdatePwd.vue')
      },
      {
        path: 'buy',
        name: 'buy',
        component: () => import('@/views/front/Buy.vue')
      },
      {
        path: 'sell',
        name: 'sell',
        component: () => import('@/views/front/Sell.vue')
      },
      {
        path: 'buy/game',
        name: 'game',
        component: () => import('@/views/front/Game.vue')
      },
      {
        path: 'buy/game/account',
        name: 'account',
        component: () => import('@/views/front/Account.vue')
      },
      {
        path: 'seller',
        name: 'sellerPage',
        component: () => import('@/views/front/SellerPage.vue')
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/front/Notice.vue')
      },
      {
        path: 'notice/noticeView/:noticeId',
        name: 'noticeView',
        component: () => import('@/views/front/NoticeView.vue')
      },
      {
        path: 'chat',
        name: 'chat',
        component: () => import('@/views/front/Chat.vue')
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/front/Contact.vue')
      },
      {
        path: 'myOrder',
        name: 'myOrder',
        component: () => import('@/views/front/Order.vue')
      },
      {
        path: 'myCollectionRecord',
        name: 'myCollectionRecord',
        component: () => import('@/views/front/MyCollectionRecord.vue')
      },
    ]
  },
  {
    path: '/403',
    name: '403',
    meta: '403',
    component: () => import('@/views/403.vue')
  },
]

const routes = [
  ...adminRouters, ...frontRouters
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const whiteList = ['/', '/register','/privacyPolicy', '/admin','/403']; // 定义白名单路径


import { authentication } from "@/api/user";
import { Message } from "element-ui";


router.beforeEach(async (to, from, next) => {
  // 检查是否在白名单中
  if (whiteList.includes(to.path)) {
    next(); // 在白名单中，直接允许访问
  } else {
    const res = await authentication()
    console.log(res)
    if (res.code == 200){
      next(); // 认证通过，允许访问
    }else{
      Message.error("暂无权限访问")
      next({path: '/403'}); // 未认证，重定向到登录页
    }
  }
});

export default router
